import { Component, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
    AccessibilityFastTrackRepoService,
} from '@client/app/services/api/accessibility/accessibility-fast-track-repo/accessibility-fast-track-repo.service';

@Component({
    selector: 'mon-audit-log-undo-review-check-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TranslocoModule,
        TableModule,
        InputTextModule,
        ButtonModule,
    ],
    templateUrl: './audit-log-undo-review-check-dialog.component.html',
    styleUrls: ['./audit-log-undo-review-check-dialog.component.scss'],
})

export class AuditLogUndoReviewCheckDialogComponent implements OnInit {

    comment: string = '';
    domainId: string | number = '';
    sourceCodeId: string | number = '';
    checkId: string | number = '';

    constructor (
        readonly dialogRef: DynamicDialogRef,
        private readonly dialogConfig: DynamicDialogConfig,
        private readonly accessibilityFastTrackRepoService: AccessibilityFastTrackRepoService,
    ) {}

    ngOnInit (): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.domainId = this.dialogConfig.data.domain_id;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.sourceCodeId = this.dialogConfig.data.source_code_id;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.checkId = this.dialogConfig.data.check_id;
    }

    submitComment (): void {
        const params = {
            comment: this.comment,
            ignored_reviewed: false,
        };
        this.accessibilityFastTrackRepoService.undoAccessibilityCheck(
            this.domainId,
            this.sourceCodeId,
            this.checkId,
            params,
        ).then(() => {
            // TODO: Add the message when Toast component is implemented properly
            this.dialogRef.close({ success: true });
        });
    }
}
